module.exports = __webpack_public_path__ + "static/home1-8b56e693bc95f2f6e4eccc735ade10f7.jpg";